import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { PayoutRunsPage } from '@/features/staff-commission';
import { workspaceSearchSchema } from '@/patterns';
import { currentPeriod } from '@/shared/lib/dates';

export const Route = createFileRoute('/_app/staff-commission/payout-runs/')({
  validateSearch: workspaceSearchSchema,
  staticData: { crumb: 'staffCommission:nav.payoutRuns' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'staff_commission.payout', 'Staff commission payout runs'),
  component: function StaffPayoutRuns() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    const onSearchChange = (patch: Record<string, unknown>, o?: { replace?: boolean }) =>
      void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false });
    return (
      <PayoutRunsPage
        search={search}
        period={search.period ?? currentPeriod()}
        staffType={search.staffType}
        onScopeChange={(patch) => onSearchChange(patch)}
        onSearchChange={onSearchChange}
      />
    );
  },
});
